/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { ErrorType } from "../../apix-handler";
import type {
  ActionItemCountsContract,
  BuilderCardInfoContract,
  CommunicationCountsContract,
  ContactUsContract,
  OwnerUpdatesListResponse,
  SummaryOwnerUpdatesGetV2Params,
  SummaryPageUpdatesInsightsContract,
  SummaryUpdateInsightsGetV2Params,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const summaryJobContactInfoByJobIdGetV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ContactUsContract>(
    {
      url: `/apix/v2/Summary/job/${jobId}/contact-info`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSummaryJobContactInfoByJobIdGetV2QueryKey = (
  jobId?: number,
) => {
  return [`/apix/v2/Summary/job/${jobId}/contact-info`] as const;
};

export const getSummaryJobContactInfoByJobIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof summaryJobContactInfoByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryJobContactInfoByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSummaryJobContactInfoByJobIdGetV2QueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof summaryJobContactInfoByJobIdGetV2>>
  > = ({ signal }) =>
    summaryJobContactInfoByJobIdGetV2(jobId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof summaryJobContactInfoByJobIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SummaryJobContactInfoByJobIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof summaryJobContactInfoByJobIdGetV2>>
>;
export type SummaryJobContactInfoByJobIdGetV2QueryError = ErrorType<unknown>;

export function useSummaryJobContactInfoByJobIdGetV2<
  TData = Awaited<ReturnType<typeof summaryJobContactInfoByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryJobContactInfoByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSummaryJobContactInfoByJobIdGetV2QueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const summaryJobBuilderContactInfoByJobIdGetV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BuilderCardInfoContract>(
    {
      url: `/apix/v2/Summary/job/${jobId}/builder-contact-info`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSummaryJobBuilderContactInfoByJobIdGetV2QueryKey = (
  jobId?: number,
) => {
  return [`/apix/v2/Summary/job/${jobId}/builder-contact-info`] as const;
};

export const getSummaryJobBuilderContactInfoByJobIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof summaryJobBuilderContactInfoByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryJobBuilderContactInfoByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSummaryJobBuilderContactInfoByJobIdGetV2QueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof summaryJobBuilderContactInfoByJobIdGetV2>>
  > = ({ signal }) =>
    summaryJobBuilderContactInfoByJobIdGetV2(jobId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof summaryJobBuilderContactInfoByJobIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SummaryJobBuilderContactInfoByJobIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof summaryJobBuilderContactInfoByJobIdGetV2>>
>;
export type SummaryJobBuilderContactInfoByJobIdGetV2QueryError =
  ErrorType<unknown>;

export function useSummaryJobBuilderContactInfoByJobIdGetV2<
  TData = Awaited<ReturnType<typeof summaryJobBuilderContactInfoByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryJobBuilderContactInfoByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSummaryJobBuilderContactInfoByJobIdGetV2QueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const summaryJobActionItemsCountByJobIdGetV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ActionItemCountsContract>(
    {
      url: `/apix/v2/Summary/job/${jobId}/action-items/count`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSummaryJobActionItemsCountByJobIdGetV2QueryKey = (
  jobId?: number,
) => {
  return [`/apix/v2/Summary/job/${jobId}/action-items/count`] as const;
};

export const getSummaryJobActionItemsCountByJobIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof summaryJobActionItemsCountByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryJobActionItemsCountByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSummaryJobActionItemsCountByJobIdGetV2QueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof summaryJobActionItemsCountByJobIdGetV2>>
  > = ({ signal }) =>
    summaryJobActionItemsCountByJobIdGetV2(jobId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof summaryJobActionItemsCountByJobIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SummaryJobActionItemsCountByJobIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof summaryJobActionItemsCountByJobIdGetV2>>
>;
export type SummaryJobActionItemsCountByJobIdGetV2QueryError =
  ErrorType<unknown>;

export function useSummaryJobActionItemsCountByJobIdGetV2<
  TData = Awaited<ReturnType<typeof summaryJobActionItemsCountByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryJobActionItemsCountByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSummaryJobActionItemsCountByJobIdGetV2QueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const summaryJobCommunicationsCountByJobIdGetV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CommunicationCountsContract>(
    {
      url: `/apix/v2/Summary/job/${jobId}/communications/count`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSummaryJobCommunicationsCountByJobIdGetV2QueryKey = (
  jobId?: number,
) => {
  return [`/apix/v2/Summary/job/${jobId}/communications/count`] as const;
};

export const getSummaryJobCommunicationsCountByJobIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof summaryJobCommunicationsCountByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryJobCommunicationsCountByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSummaryJobCommunicationsCountByJobIdGetV2QueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof summaryJobCommunicationsCountByJobIdGetV2>>
  > = ({ signal }) =>
    summaryJobCommunicationsCountByJobIdGetV2(jobId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof summaryJobCommunicationsCountByJobIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SummaryJobCommunicationsCountByJobIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof summaryJobCommunicationsCountByJobIdGetV2>>
>;
export type SummaryJobCommunicationsCountByJobIdGetV2QueryError =
  ErrorType<unknown>;

export function useSummaryJobCommunicationsCountByJobIdGetV2<
  TData = Awaited<ReturnType<typeof summaryJobCommunicationsCountByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryJobCommunicationsCountByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSummaryJobCommunicationsCountByJobIdGetV2QueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const summaryOwnerUpdatesGetV2 = (
  params: SummaryOwnerUpdatesGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<OwnerUpdatesListResponse>(
    { url: `/apix/v2/Summary/owner-updates`, method: "GET", params, signal },
    options,
  );
};

export const getSummaryOwnerUpdatesGetV2QueryKey = (
  params?: SummaryOwnerUpdatesGetV2Params,
) => {
  return [
    `/apix/v2/Summary/owner-updates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSummaryOwnerUpdatesGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof summaryOwnerUpdatesGetV2>>,
  TError = ErrorType<unknown>,
>(
  params: SummaryOwnerUpdatesGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryOwnerUpdatesGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSummaryOwnerUpdatesGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof summaryOwnerUpdatesGetV2>>
  > = ({ signal }) => summaryOwnerUpdatesGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof summaryOwnerUpdatesGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SummaryOwnerUpdatesGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof summaryOwnerUpdatesGetV2>>
>;
export type SummaryOwnerUpdatesGetV2QueryError = ErrorType<unknown>;

export function useSummaryOwnerUpdatesGetV2<
  TData = Awaited<ReturnType<typeof summaryOwnerUpdatesGetV2>>,
  TError = ErrorType<unknown>,
>(
  params: SummaryOwnerUpdatesGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryOwnerUpdatesGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSummaryOwnerUpdatesGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const summaryUpdateInsightsGetV2 = (
  params?: SummaryUpdateInsightsGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SummaryPageUpdatesInsightsContract>(
    { url: `/apix/v2/Summary/update-insights`, method: "GET", params, signal },
    options,
  );
};

export const getSummaryUpdateInsightsGetV2QueryKey = (
  params?: SummaryUpdateInsightsGetV2Params,
) => {
  return [
    `/apix/v2/Summary/update-insights`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSummaryUpdateInsightsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof summaryUpdateInsightsGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SummaryUpdateInsightsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryUpdateInsightsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSummaryUpdateInsightsGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof summaryUpdateInsightsGetV2>>
  > = ({ signal }) =>
    summaryUpdateInsightsGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof summaryUpdateInsightsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SummaryUpdateInsightsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof summaryUpdateInsightsGetV2>>
>;
export type SummaryUpdateInsightsGetV2QueryError = ErrorType<unknown>;

export function useSummaryUpdateInsightsGetV2<
  TData = Awaited<ReturnType<typeof summaryUpdateInsightsGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SummaryUpdateInsightsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof summaryUpdateInsightsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSummaryUpdateInsightsGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
